<div class="chat-layout" [class.chat-layout_col-2]="detailsVisible && isLargeScreen">
  <div [hide]="!showFullPage" class="chat-layout__chat chat">
    <div *ngIf="chat" class="chat__header">
      <div class="header" (click)="onClickDetailButton()">
        <div class="header__photo">
          <tui-avatar
            [src]="chat.userPhotoPath ? (chat.userPhotoPath | safe: 'url') : (chat.title | tuiInitials)"
            [size]="'m'"
            [round]="true"
            [style.background]="!chat.userPhotoPath && chat.title ? (chat.title | tuiAutoColor) : ('' | tuiAutoColor)"
          ></tui-avatar>
        </div>

        <div class="header__info info">
          <div class="info__title">{{ chat.title }}</div>

          <div class="info__status">
            <ng-container *ngIf="bot">{{ 'common.labels.bot' | translate }}</ng-container>

            <ng-container *ngIf="user">
              {{ chat.actionStatus ? (chat.actionStatus | actionStatus | async) : (user.status | userStatus) }}
            </ng-container>

            <ng-container *ngIf="superGroup">
              {{
                superGroup
                  ? (superGroup.memberCount
                    | numeralPlurals
                      : [
                          'components.telegramChat.labels.memberOne' | translate,
                          'components.telegramChat.labels.memberFew' | translate,
                          'components.telegramChat.labels.memberMany' | translate,
                        ])
                  : ''
              }}
            </ng-container>

            <ng-container *ngIf="basicGroup">
              {{
                basicGroup
                  ? (basicGroup.members.length
                    | numeralPlurals
                      : [
                          'components.telegramChat.labels.memberOne' | translate,
                          'components.telegramChat.labels.memberFew' | translate,
                          'components.telegramChat.labels.memberMany' | translate,
                        ])
                  : ''
              }}
            </ng-container>
          </div>
        </div>
      </div>

      <div class="header-actions">
        <button
          tuiIconButton
          class="header-actions__details"
          type="button"
          appearance="icon"
          iconStart="@tui.layout"
          size="s"
          [tuiHint]="'components.telegramChat.buttons.details' | translate"
          (click)="onClickDetailButton()"
        ></button>

        <div
          *ngIf="isChatPage"
          class="header-actions__menu"
          tuiDropdownAlign="left"
          [tuiDropdown]="actionMenuTemplate"
          [(tuiDropdownOpen)]="actionMenuOpened"
        >
          <button
            tuiIconButton
            type="button"
            appearance="icon"
            iconStart="@tui.ellipsis-vertical"
            size="s"
            [tuiHint]="'components.telegramChat.buttons.moreActions' | translate"
          ></button>
        </div>
      </div>
    </div>

    <div class="chat__pinned-message-list">
      <telegram-pinned-message-list
        [chatId]="chat?.id"
        (scrollToMessageId)="scrollToMessage($event)"
      ></telegram-pinned-message-list>
    </div>

    <div class="chat__body">
      <app-message-list
        *ngIf="chat; else hint"
        [chat]="chat"
        [scrollToMessageId]="scrollToMessageId"
        [(replyToMessageId)]="replyToMessageId"
        [(editMessageId)]="editMessageId"
        (editMessageIdChange)="editMessageIdChange($event)"
        (forwardToChatId)="forwardToChat($event)"
      ></app-message-list>

      <ng-template #hint>
        <div class="hint__wrap">
          <div class="hint">{{ 'components.telegramChat.labels.selectChat' | translate }}</div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="chat && currentUserChatStatus" class="chat__footer footer">
      <ng-container
        *ngIf="
          currentUserChatStatus &&
            (chat.type._ === 'chatTypeBasicGroup' || (chat.type._ === 'chatTypeSupergroup' && !chat.type.isChannel)) &&
            currentUserChatStatus._ !== 'chatMemberStatusCreator' &&
            ((currentUserChatStatus._ === 'chatMemberStatusRestricted' &&
              !currentUserChatStatus.permissions.canSendMessages) ||
              (currentUserChatStatus._ === 'chatMemberStatusMember' && !chatPermissions?.canSendMessages));
          else footerButton
        "
      >
        <div
          class="footer__text"
          *ngIf="
            currentUserChatStatus &&
            currentUserChatStatus._ === 'chatMemberStatusRestricted' &&
            !currentUserChatStatus.permissions.canSendMessages
          "
        >
          {{ 'components.telegramChat.labels.chatMemberStatusRestricted' | translate }}
        </div>

        <div
          class="footer__text"
          *ngIf="
            currentUserChatStatus &&
            currentUserChatStatus._ === 'chatMemberStatusMember' &&
            !chatPermissions?.canSendMessages
          "
        >
          {{ 'components.telegramChat.labels.groupSendMessagesForbiden' | translate }}
        </div>
      </ng-container>

      <ng-template #footerButton>
        <ng-container
          *ngIf="
            chat.type._ === 'chatTypeSupergroup' &&
              chat.type.isChannel &&
              currentUserChatStatus &&
              currentUserChatStatus._ !== 'chatMemberStatusCreator';
            else footerControl
          "
        >
          <div class="footer__button">
            <button tuiButton type="button" [size]="'m'" (click)="onChangeNotificationsToggleValue()">
              {{
                chat.notificationSettings.muteFor === 0
                  ? ('components.telegramChat.buttons.notificationsOff' | translate)
                  : ('components.telegramChat.buttons.notificationsOn' | translate)
              }}
            </button>
          </div>
        </ng-container>

        <ng-template #footerControl>
          <telegram-conversation-box-input
            [(replyToMessageId)]="replyToMessageId"
            [(editMessageId)]="editMessageId"
            [(newMessage)]="newMessage"
            [chat]="chat"
            [allowAttachment]="
              !(
                currentUserChatStatus &&
                currentUserChatStatus._ === 'chatMemberStatusRestricted' &&
                !currentUserChatStatus.permissions.canSendMediaMessages
              )
            "
          ></telegram-conversation-box-input>
        </ng-template>
      </ng-template>
    </div>
  </div>

  <div *ngIf="detailsVisible" class="chat-layout__details details">
    <div class="details__header">
      <div class="header__title">{{ 'components.telegramChat.labels.info' | translate }}</div>
      <div class="header__button header__button_close">
        <button
          tuiIconButton
          class="button_close"
          type="button"
          appearance="icon"
          iconStart="@tui.x"
          size="s"
          [tuiHint]="'common.buttons.close' | translate"
          (click)="onClickDetailButton()"
        ></button>
      </div>
    </div>

    <tui-scrollbar class="details__content">
      <telegram-user *ngIf="user" [userTelegram]="user" [chat]="chat"></telegram-user>
      <telegram-bot *ngIf="bot" [bot]="bot" [chat]="chat"></telegram-bot>
      <telegram-group *ngIf="superGroup" [superGroup]="superGroup" [chat]="chat"></telegram-group>
      <telegram-group *ngIf="basicGroup" [basicGroup]="basicGroup" [chat]="chat"></telegram-group>
    </tui-scrollbar>
  </div>
</div>

<ng-template #confirmDeleteDialogTemplate let-observer>
  <p>{{ 'common.dialogs.areYouSureTitle' | translate }}</p>
  <div class="tui-space_bottom-3">
    <label
      *ngIf="currentUserChatStatus && currentUserChatStatus._ === 'chatMemberStatusCreator'"
      [tuiBlock]="tuiElementMediumSize"
    >
      <input tuiCheckbox type="checkbox" [(ngModel)]="deleteFromTelegram" />
      {{ 'components.telegramChat.labels.deleteFromTelegram' | translate }}
    </label>
  </div>
  <button
    tuiButton
    type="button"
    class="tui-space_right-3"
    [size]="tuiElementMediumSize"
    (click)="applyChatDelete(observer)"
  >
    {{ 'common.buttons.yes' | translate }}
  </button>
  <button tuiButton type="button" appearance="secondary" [size]="tuiElementMediumSize" (click)="observer.complete()">
    {{ 'common.buttons.no' | translate }}
  </button>
</ng-template>

<ng-template #actionMenuTemplate>
  <tui-data-list class="menu-list">
    <ng-container *ngFor="let item of actionMenuItems">
      <button *ngIf="item.visible()" tuiOption class="menu-list__item" (click)="item.action()">
        <tui-icon class="menu-list__icon" [icon]="item.iconName"></tui-icon>
        {{ item.title }}
      </button>
    </ng-container>
  </tui-data-list>
</ng-template>
